import { useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Dialog, DialogTitle, Grid } from "@mui/material";
import FormField from "../../../components/form-controls/form-field";
import theme from "../../../app/app-theme";
import FormCloseButton from "../../../components/form-controls/form-close-button";
import { FormTextField } from "../../../components/form-input-field-wrappers/form-controller-inputs/form-text-field";
import { BiometricDevice, BiometricDeviceRequest } from "../../../service/model/biometric.model";

interface BiometricDeviceFormProps {
    readonly device?: BiometricDevice
    readonly editable: boolean
    readonly onClose: () => void
    readonly onSubmit: (data: BiometricDeviceRequest) => void
}

const style = {
    // position: 'absolute' as 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // width: 400,
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    p: 2,
};

const BiometricDeviceForm: React.FC<BiometricDeviceFormProps> = ({ device, editable, onClose, onSubmit }) => {
    const schema = yup.object().shape({
        serialNumber: yup.string()
            .required("Serial Number is required"),
        deviceName: yup.string()
            .required("Device Name is required"),
        model: yup.string()
            .required("Model is required"),
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmitHandler = (data: any) => {
        onSubmit({...data, enabled: true} as BiometricDeviceRequest)
    };

    return (
        <Dialog open={true} onClose={onClose} sx={style}>
            <DialogTitle>Biometric Device Details</DialogTitle>
            <Box sx={style}>
                <>
                    <FormCloseButton onClose={onClose} />
                    <form onSubmit={handleSubmit(onSubmitHandler)}>
                        <FormField>
                            <FormTextField
                                id="serial-number"
                                label="Serial Number"
                                name="serialNumber"
                                variant="outlined"
                                defaultValue={device?.serialNumber}
                                error={errors.serialNumber !== undefined}
                                helperText={errors.serialNumber?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="device-name"
                                label="Device Name"
                                name="deviceName"
                                variant="outlined"
                                defaultValue={device?.deviceName}
                                error={errors.deviceName !== undefined}
                                helperText={errors.deviceName?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="model"
                                label="Model"
                                name="model"
                                variant="outlined"
                                defaultValue={device?.model}
                                error={errors.model !== undefined}
                                helperText={errors.model?.message}
                                register={register}
                            />
                        </FormField>
                        <Grid container direction="row" justifyContent='end' sx={{ mt: 1 }}>
                            <Button type="button" variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={onClose}>Cancel</Button>
                            <Button type="submit" variant="contained" >Submit</Button>
                        </Grid>
                    </form>
                </>
            </Box>
        </Dialog>
    );
}

export default BiometricDeviceForm;